module.exports = __webpack_public_path__ + "fonts/70df980ffae5c129214b40db64bbe01d.txt";